/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  var openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  var summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
var FacetFiltersForm = /*#__PURE__*/function (_HTMLElement) {
  function FacetFiltersForm() {
    var _this2;
    _classCallCheck(this, FacetFiltersForm);
    _this2 = _callSuper(this, FacetFiltersForm);
    _this2.onActiveFilterClick = _this2.onActiveFilterClick.bind(_this2);
    _this2.debouncedOnSubmit = debounce(function (event) {
      _this2.onSubmitHandler(event);
    }, 500);
    var facetForm = _this2.querySelector('form');
    facetForm.addEventListener('input', _this2.debouncedOnSubmit.bind(_this2));
    if (window.CrepslockerFilters) facetForm.addEventListener('submit', function (event) {
      event.preventDefault();
      _this2.onSubmitForm(_this2.createSearchParams(facetForm), event);
    });
    var facetWrapper = _this2.querySelector('#FacetsWrapper');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Add the event listener for checking filter changes
    facetForm.addEventListener('change', function (event) {
      // Check if the changed element is a filter but not the "in stock" filter
      if (event.target.matches('.filter-input:not([name="filter.v.availability"]):not([name="filter.p.m.custom.fully_sold_out"])') &&
          !_this2.querySelector('input[name="filter.p.m.custom.fully_sold_out"]:checked')) {
        // Find the "in stock" checkbox and select it
        var availabilityFilter = _this2.querySelector('input[name="filter.v.availability"]');
        if (availabilityFilter) {
          availabilityFilter.checked = true;
          // Dispatch the change event for availability filter
          availabilityFilter.dispatchEvent(new Event('change'));
        }
      }

      // After updating the in stock checkbox or any other facet, update the URL
      var searchParams = _this2.createSearchParams(facetForm);
      if (!window.CrepslockerFilters) FacetFiltersForm.updateURLHash(searchParams);
    });
    return _this2;
  }
  _inherits(FacetFiltersForm, _HTMLElement);
  return _createClass(FacetFiltersForm, [{
    key: "createSearchParams",
    value: function createSearchParams(form) {
      var formData = new FormData(form);
      if (window.CrepslockerFilters) {
        var params = new URLSearchParams(window.location.search);
        Array.from(params.keys()).forEach(function (key) {
          if (key.indexOf('filter.') === 0 || ['sort_by', 'page', 'sections', 'section_id', 'view'].includes(key)) params.delete(key);
        });
        formData.forEach(function (value, key) { params.append(key, value); });
        return params.toString();
      }
      return new URLSearchParams(formData).toString();
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }
  }, {
    key: "onSubmitHandler",
    value: function onSubmitHandler(event) {
      var _this3 = this;
      event.preventDefault();
      var sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event.srcElement.className == 'facets__checkbox') {
        var searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      } else {
        var forms = [];
        var isMobile = event.target.closest('form').id === 'FacetFiltersForm';
        sortFilterForms.forEach(function (form) {
          if (!isMobile) {
            if (form.id === 'FacetFiltersForm') {
              var noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach(function (el) {
                return el.remove();
              });
              forms.push(_this3.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersForm') {
            forms.push(_this3.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      }
    }
  }, {
    key: "onActiveFilterClick",
    value: function onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      var url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  }, {
    key: "sortListItems",
    value: function sortListItems() {
      var list = this.querySelector('ul.sort-num');
      if (!list) return;
      var items = Array.from(list.querySelectorAll('li'));
      var sortedItems = items.sort(function (a, b) {
        var aValue = parseInt(a.getAttribute('data-sort').match(/\d+/));
        var bValue = parseInt(b.getAttribute('data-sort').match(/\d+/));
        return aValue - bValue;
      });
      sortedItems.forEach(function (item) {
        return list.appendChild(item);
      });
    }
  }], [{
    key: "setListeners",
    value: function setListeners() {
      var onHistoryChange = function onHistoryChange(event) {
        var searchParams = window.CrepslockerFilters ? window.location.search.slice(1) : (event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial);
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);
    }
  }, {
    key: "toggleActiveFacets",
    value: function toggleActiveFacets() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      document.querySelectorAll('.js-facet-remove').forEach(function (element) {
        element.classList.toggle('disabled', disable);
      });
    }
  }, {
    key: "renderPage",
    value: function renderPage(searchParams, event) {
      var updateURLHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      FacetFiltersForm.searchParamsPrev = searchParams;
      if (window.CrepslockerFilters) return window.CrepslockerFilters.render(searchParams, updateURLHash);
      var sections = FacetFiltersForm.getSections();
      var countContainer = document.getElementById('ProductCount');
      // const countContainerTotal = document.getElementById('ProductCountTotal');
      document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      sections.forEach(function (section) {
        var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
        var filterDataUrl = function filterDataUrl(element) {
          return element.url === url;
        };
        FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  }, {
    key: "renderSectionFromFetch",
    value: function renderSectionFromFetch(url, event) {
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        FacetFiltersForm.filterData = [].concat(_toConsumableArray(FacetFiltersForm.filterData), [{
          html: html,
          url: url
        }]);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.initLoadMore();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        //get list items again and sort
        document.querySelectorAll('.sort-num').forEach(function (list) {
          sortAllListItems(list);
        });
      });
    }
  }, {
    key: "renderSectionFromCache",
    value: function renderSectionFromCache(filterDataUrl, event) {
      var html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.initLoadMore();
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }
  }, {
    key: "renderProductGridContainer",
    value: function renderProductGridContainer(html) {
      document.getElementById('CollectionProductGrid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductGrid').innerHTML;

      //console.log('renderProductGrid');
      setupQuickbuys();
      document.getElementById('CollectionProductGrid').querySelectorAll('.scroll-trigger').forEach(function (element) {
        element.classList.add('scroll-trigger--cancel');
      });
    }
  }, {
    key: "renderProductCount",
    value: function renderProductCount(html) {
      //console.log('renderProductCount running')
      var count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      var container = document.getElementById('ProductCount');
      var containerTotal = document.getElementById('ProductCountPagination');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerTotal) {
        containerTotal.innerHTML = count;
        containerTotal.classList.remove('loading');
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters(html, event) {
      //console.log('renderFilters running');
      var parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      // why iterate instead of just replacing the entire container?
      var facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
      var matchesIndex = function matchesIndex(element) {
        var jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      };
      var facetsToRender = Array.from(facetDetailsElements).filter(function (element) {
        return !matchesIndex(element);
      });
      var countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
      facetsToRender.forEach(function (element) {
        var targetElement = document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]"));
        if (targetElement) {
          targetElement.innerHTML = element.innerHTML;
        }
      });
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      // FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
      document.querySelectorAll('.sort-num').forEach(function (list) {
        sortAllListItems(list);
      });
      var ajaxFiltersUpdated = new Event('ajaxFiltersUpdated');
      document.dispatchEvent(ajaxFiltersUpdated);
    }
  }, {
    key: "renderActiveFacets",
    value: function renderActiveFacets(html) {
      var activeFacetElementSelectors = ['.active-facets'];
      activeFacetElementSelectors.forEach(function (selector) {
        var activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      });
      FacetFiltersForm.toggleActiveFacets(false);
    }
  }, {
    key: "renderCounts",
    value: function renderCounts(source, target) {
      var targetElement = target.querySelector('.facets__selected');
      var sourceElement = source.querySelector('.facets__selected');
      var targetElementAccessibility = target.querySelector('.facets__summary');
      var sourceElementAccessibility = source.querySelector('.facets__summary');
      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }
      if (targetElementAccessibility && sourceElementAccessibility) {
        target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      }
    }
  }, {
    key: "updateURLHash",
    value: function updateURLHash(searchParams) {
      // Remove page=1, page=2, etc. from the searchParams
      var cleanedSearchParams = searchParams.replace(/&?page=\d+/g, '');

      //history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      history.pushState({
        searchParams: cleanedSearchParams
      }, '', "".concat(window.location.pathname).concat(cleanedSearchParams && '?'.concat(cleanedSearchParams)));
    }
  }, {
    key: "getSections",
    value: function getSections() {
      return [{
        section: document.getElementById('main-collection-product-grid').dataset.id
      }];
    }
  }, {
    key: "initLoadMore",
    value: function initLoadMore() {
      new LoadMore(); // Initialize the LoadMore class
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
if (window.CrepslockerFilters) window.CrepslockerFilters.init(sortAllListItems);

//mf -  this seems to just sort the size filters into the correct order, not actually modify the order of the products - better to do this with liquid i think
function sortAllListItems(list) {
  // const list = document.querySelector('ul.sort-num');//removed as we're now iterating through multiple lists
  if (!list) {
    console.log('No list provided for sortAllListItems');
    return;
  }
  var items = Array.from(list.querySelectorAll('li'));

  // Create a mapping for size labels
  var sizeMapping = {
    "xxs": 0,
    "xs": 1,
    "s": 2,
    "m": 3,
    "l": 4,
    "xl": 5,
    "xxl": 6,
    "xxxl": 7,
    "xxxxl": 8
  };

  // Sort the items based on data-sort attribute value
  var sortedItems = items.sort(function (a, b) {
    var aValueStr = a.getAttribute('data-sort').toLowerCase().trim();
    var bValueStr = b.getAttribute('data-sort').toLowerCase().trim();
    var aIsSize = sizeMapping.hasOwnProperty(aValueStr);
    var bIsSize = sizeMapping.hasOwnProperty(bValueStr);
    var aValue, bValue;
    if (aIsSize && bIsSize) {
      aValue = sizeMapping[aValueStr];
      bValue = sizeMapping[bValueStr];
    } else if (aIsSize) {
      return -1; // Sizes come first
    } else if (bIsSize) {
      return 1; // Sizes come first
    } else {
      // Fallback to number comparison
      aValue = parseInt(aValueStr.match(/\d+/));
      bValue = parseInt(bValueStr.match(/\d+/));
    }
    return aValue - bValue;
  });

  // Append sorted items back to the list
  sortedItems.forEach(function (item) {
    return list.appendChild(item);
  });
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.sort-num').forEach(function (list) {
    sortAllListItems(list);
  });
});
var PriceRange = /*#__PURE__*/function (_HTMLElement2) {
  function PriceRange() {
    var _this4;
    _classCallCheck(this, PriceRange);
    _this4 = _callSuper(this, PriceRange);
    _this4.querySelectorAll('input').forEach(function (element) {
      return element.addEventListener('change', _this4.onRangeChange.bind(_this4));
    });
    _this4.setMinAndMaxValues();
    _this4.rangeSliderPrice();
    return _this4;
  }
  _inherits(PriceRange, _HTMLElement2);
  return _createClass(PriceRange, [{
    key: "onRangeChange",
    value: function onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  }, {
    key: "setMinAndMaxValues",
    value: function setMinAndMaxValues() {
      var inputs = this.querySelectorAll('input');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }, {
    key: "adjustToValidValues",
    value: function adjustToValidValues(input) {
      var value = Number(input.value);
      var min = Number(input.getAttribute('min'));
      var max = Number(input.getAttribute('max'));
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }, {
    key: "rangeSliderPrice",
    value: function rangeSliderPrice() {
      var _this5 = this;
      var rangeS = this.querySelectorAll("input[type=range]"),
        numberS = this.querySelectorAll("input[type=number]");
      rangeS.forEach(function (element) {
        element.oninput = function () {
          var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);
          if (slide1 > slide2) {
            //slide1.value = slide2.value - 1;
            var _ref = [slide2, slide1];
            slide1 = _ref[0];
            slide2 = _ref[1];
          }
          numberS[0].value = slide1;
          numberS[1].value = slide2;
          _this5.updateDisplay(slide1, slide2);
        };
      });
      numberS.forEach(function (element) {
        element.oninput = function () {
          var number1 = parseFloat(numberS[0].value),
            checkValue1 = number1 != number1,
            number2 = parseFloat(numberS[1].value),
            checkValue2 = number2 != number2;
          if (!checkValue1) {
            rangeS[0].value = number1;
          }
          if (!checkValue2) {
            rangeS[1].value = number2;
          }
          if (number1 > number2) {
            _this5.updateDisplay(number2, number1);
          } else {
            _this5.updateDisplay(number1, number2);
          }
        };
      });
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay(value1, value2) {
      var range = this.querySelector("input[type=range]");
      var priceSlideRangeContainer = this.querySelector('.facets__price--slide');
      var max = range.max;
      var width = priceSlideRangeContainer.clientWidth;
      var leftSpace = parseInt(value1) / parseInt(max) * width + 'px';
      var rightSpace = width - parseInt(value2) / parseInt(max) * width + 'px';
      priceSlideRangeContainer.style.setProperty('--left-space', leftSpace);
      priceSlideRangeContainer.style.setProperty('--right-space', rightSpace);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('price-range', PriceRange);
var FacetRemove = /*#__PURE__*/function (_HTMLElement3) {
  function FacetRemove() {
    var _this6;
    _classCallCheck(this, FacetRemove);
    _this6 = _callSuper(this, FacetRemove);
    var facetLink = _this6.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', _this6.closeFilter.bind(_this6));
    facetLink.addEventListener('keyup', function (event) {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') _this6.closeFilter(event);
    });
    return _this6;
  }
  _inherits(FacetRemove, _HTMLElement3);
  return _createClass(FacetRemove, [{
    key: "closeFilter",
    value: function closeFilter(event) {
      event.preventDefault();
      var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('facet-remove', FacetRemove);

// Define LoadMore class
var LoadMore = /*#__PURE__*/function () {
  function LoadMore() {
    _classCallCheck(this, LoadMore);
    this.loadMoreButton = document.querySelector(".load-more-button");
    // Check if loadMoreButton exists before using it
    if (this.loadMoreButton) {
      this.nextPageUrl = this.loadMoreButton.getAttribute("next-page");
      this.loadingSVG = this.loadMoreButton.querySelector('svg');
      this.removePreviousListeners();
      this.initLoadMoreButton();
      this.loadingSVG = this.loadMoreButton.querySelector('.load-more-animate');
    } else {
      this.nextPageUrl = null; // or some default value
      this.loadingSVG = null; // or some default value
    }
    this.productGrid = document.querySelector(".productListing");
    this.productGridContainer = document.getElementById("main-collection-product-grid");
    this.totalProductsCount = document.querySelector(".total-products-count");
    this.loadedProductsCount = document.querySelector(".loaded-products-count");
    this.progressBar = document.querySelector(".progress-bar");
    this.totalResults = this.productGrid ? this.productGrid.querySelectorAll('li').length : 0;
    this.loadedResults = this.totalResults;
    this.clicked = false;
    if (this.loadMoreButton) {
      // Make sure loadMoreButton exists
      this.removePreviousListeners();
      this.initLoadMoreButton();
      this.loadingSVG = this.loadMoreButton.querySelector('.load-more-animate');
    }
  }
  return _createClass(LoadMore, [{
    key: "removePreviousListeners",
    value: function removePreviousListeners() {
      var newButton = this.loadMoreButton.cloneNode(true);
      this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
      this.loadMoreButton = newButton;
    }
  }, {
    key: "initLoadMoreButton",
    value: function initLoadMoreButton() {
      var _this7 = this;
      this.loadMoreButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (!_this7.clicked) {
          _this7.loadingSVG.classList.remove('hidden'); // This should now work as expected
          _this7.clicked = true;
          _this7.getNextPageData(_this7.nextPageUrl);
        }
      });
    }
  }, {
    key: "getNextPageData",
    value: function getNextPageData(url) {
      var _this8 = this;
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        _this8.injectNewProductGridItems(doc);
        _this8.updateButton(doc);
      })["catch"](function (error) {
        return console.error("Error: ", error);
      })["finally"](function () {
        _this8.loadingSVG.classList.add('hidden');
        _this8.updateProgressBar();
        // window.history.pushState({}, "", url);
      });
    }
  }, {
    key: "injectNewProductGridItems",
    value: function injectNewProductGridItems(doc) {
      var _this$productGrid;
      var newItems = doc.querySelectorAll("#main-collection-product-grid>li");
      newItems.forEach(function (item) {
        item.querySelector("img").setAttribute("loading", "eager");
      });
      (_this$productGrid = this.productGrid).append.apply(_this$productGrid, _toConsumableArray(newItems));
      this.loadedResults += newItems.length;
      this.loadedProductsCount.textContent = this.loadedResults;
    }
  }, {
    key: "updateButton",
    value: function updateButton(doc) {
      this.nextPageUrl = doc.querySelector(".load-more-button").getAttribute("next-page");
      this.loadMoreButton.setAttribute("next-page", this.nextPageUrl);
      this.loadMoreButton.setAttribute("href", this.nextPageUrl);
      if (this.nextPageUrl) {
        this.clicked = false;
        this.loadMoreButton.querySelector('span').textContent = "Load More";
      } else {
        this.loadMoreButton.querySelector('span').textContent = "No more items";
        this.loadMoreButton.setAttribute('disabled', 'true');
      }
    }

    // Update the progress bar
  }, {
    key: "updateProgressBar",
    value: function updateProgressBar() {
      this.totalResults = parseInt(this.totalProductsCount.textContent);
      var progress = this.loadedResults / this.totalResults * 100;
      this.progressBar.style.width = "".concat(progress, "%");
      this.progressBar.setAttribute("aria-valuenow", progress);
    }
  }]);
}(); // Create a new instance of LoadMore
var loadMore = new LoadMore();

//used to hide the filters that match no available items
//unfortunately the liquid filter.count includes sold out items so we need to run js to get the count after availability filter is applied to the url.
function fetchAndHideZeroCountFacets() {
  console.log('fetch and hide zero count facets');
  var currentURL = window.location.href;
  var inStockURL = currentURL.includes("?") ? "".concat(currentURL, "&filter.v.availability=1") : "".concat(currentURL, "?filter.v.availability=1");
  fetch(inStockURL).then(function (response) {
    return response.text();
  }).then(function (htmlString) {
    hideZeroCountFacetsUsingHTML(htmlString);
  })["catch"](function (error) {
    console.error("There was an error fetching in-stock facets:", error);
  });
}
function hideZeroCountFacetsUsingHTML(htmlString) {
  //console.log('hideZeroCountFacets')
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, 'text/html');
  var fetchedFacets = Array.from(doc.querySelectorAll('.facets__item')).map(function (facetElement) {
    var facetLabel = facetElement.querySelector("span[aria-hidden='true']").innerText;
    var id = facetElement.querySelector("span[aria-hidden='true']").id;

    // Using the new class to select the count span
    var count = parseInt(facetElement.querySelector(".count").innerText.replace(/[()]/g, ""), 10);
    return {
      label: facetLabel,
      count: count,
      id: id
    };
  });
  document.querySelectorAll('.facets__item').forEach(function (facetElement) {
    // const facetLabel = facetElement.querySelector("span[aria-hidden='true']").innerText;
    // const matchingFacet = fetchedFacets.find(facet => facet.label === facetLabel);

    var facetLabel = facetElement.querySelector("span[aria-hidden='true']").id;
    var matchingFacet = fetchedFacets.find(function (facet) {
      return facet.id === facetLabel;
    });
    if (matchingFacet) {
      // Update the count for the facet
      var countSpan = facetElement.querySelector(".count");
      countSpan.innerText = "(".concat(matchingFacet.count, ")");

      // Hide facet if count is 0
      if (matchingFacet.count === 0) {
        facetElement.classList.add('hidden');
      } else {
        facetElement.classList.remove('hidden');
      }
    }
  });
  var facetsHiddenEvent = new Event('facetsHiddenEvent');
  document.dispatchEvent(facetsHiddenEvent);
}
if (!window.CrepslockerFilters) fetchAndHideZeroCountFacets();
// fetchAndHideZeroCountFacets()

//function fillGridGaps() {
// const grid = document.querySelector('.productListing');
// const products = grid.querySelectorAll('.product');
// const promoCard = grid.querySelector('#promo-card');
// let numberOfColumns = 2; // default for mobile

// // Detect viewport width to determine columns (this assumes tailwindcss breakpoints)
// const width = window.innerWidth;
// if (width >= 1024) { // lg breakpoint in tailwindcss
//     numberOfColumns = 4;
// } else if (width >= 768) { // md breakpoint in tailwindcss
//     numberOfColumns = 2;
// }

// const totalItems = promoCard ? products.length + 1: products.length; // including promo-card // mf - adjusted to check if promoCard is found
// const gap = (numberOfColumns - (totalItems % numberOfColumns)) % numberOfColumns;

// let productToCloneIndex = 0;
// for (let i = 0; i < gap; i++) {
//     const clonedProduct = products[productToCloneIndex].cloneNode(true); // deep clone
//     grid.appendChild(clonedProduct);

//     productToCloneIndex++;
//     if (productToCloneIndex >= products.length) {
//         productToCloneIndex = 0; // cycle back to the start
//     }
// }

// // Move promo-card to desired position, e.g., after first product // mf - this already seems to be done with liquid?
// if (promoCard) {
//     grid.insertBefore(promoCard, products[1]);
// }
//}

// On DOM loaded or whenever you need to adjust
//document.addEventListener("DOMContentLoaded", fillGridGaps);
////window.addEventListener("resize", fillGridGaps); // optional, if you want to adjust on window resize

var collectionDescription = function collectionDescription() {
  var showChar = 300; // How many characters are shown by default
  var moretext = "Read More";
  var lesstext = "Read Less";
  var descriptionElements = document.querySelectorAll('.collection-description');
  descriptionElements.forEach(function (element) {
    var fullContent = element.innerHTML;
    if (fullContent.length > showChar) {
      element.dataset.fullContent = fullContent; // Store full content in data attribute
      element.innerHTML = fullContent.substr(0, showChar);
      var showMoreButton = element.nextElementSibling;
      showMoreButton.addEventListener('click', function () {
        if (showMoreButton.textContent === moretext) {
          element.innerHTML = element.dataset.fullContent; // Expand the description
          showMoreButton.textContent = lesstext;
        } else {
          element.innerHTML = fullContent.substr(0, showChar); // Collapse the description
          showMoreButton.textContent = moretext;
        }
      });
    } else {
      // If content length is less than showChar, hide the show-more-button
      var _showMoreButton = element.nextElementSibling;
      if (_showMoreButton) {
        _showMoreButton.style.display = 'none';
      }
    }
  });
};

// Calling function after Page Load
document.addEventListener('DOMContentLoaded', function () {
  //console.log('DOMContentLoaded');
  // collectionDescription();
});

// document.addEventListener("DOMContentLoaded", function () {

//     // Get the current window location's search string
//     var currentPage = window.location.search;
//     var currentURL = window.location.href;

//     // Define the range of pages to check
//     var pagesToCheck = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
//     var found = false;

//     for (let i = 0; i < pagesToCheck.length; i++) {
//         if (currentPage.includes('page=' + pagesToCheck[i])) {
//             found = true;
//             break;
//         }
//     }

//     var navigationElement = document.querySelector('.pagination-wrapper');
//     var loadmoreElement = document.querySelector('.collection-loadmore');
//     if (navigationElement) {
//         if (found) {
//             navigationElement.classList.remove('sr-only');
//             loadmoreElement.classList.add('hidden');
//         } else {
//             navigationElement.classList.add('sr-only');
//             loadmoreElement.classList.remove('hidden');
//         }
//     }
// });

// class LoadMoreProducts {
//     constructor() {
//         this.pageNum = this.getCurrentPageNum();
//         this.handle = location.pathname.split("/")[2];
//         this.loadMoreButton = document.querySelector('.load-more-button');
//         this.productGrid = document.querySelector('#main-collection-product-grid');
//         this.totalProductsCount = document.querySelector('.total-products-count');
//         this.loadedProductsCount = document.querySelector('.loaded-products-count');
//         this.progressBar = document.querySelector('.progress-bar');
//         this.spinner = this.loadMoreButton.querySelector('.animate-spin'); // your spinner
//         this.loadMoreButtonText = this.loadMoreButton.querySelector('span'); // your button text

//         this.init();
//     }

//     getCurrentPageNum() {
//         const urlParams = new URLSearchParams(window.location.search);
//         return parseInt(urlParams.get('page')) || 1;
//     }

//     init() {
//         if (!this.loadMoreButton || !this.productGrid) return;

//         this.loadMoreButton.addEventListener('click', (e) => {
//             e.preventDefault();
//             this.pageNum += 1;
//             this.loadProducts();
//             this.spinner.classList.remove('hidden'); // show spinner
//             this.loadMoreButtonText.textContent = 'Products loading...'; // change button text
//         });
//     }

//     loadProducts() {
//         fetch(`/collections/${this.handle}?page=${this.pageNum}`)
//             .then(response => response.text())
//             .then(data => {
//                 const parser = new DOMParser();
//                 const doc = parser.parseFromString(data, 'text/html');

//                 const newProducts = doc.querySelector('#main-collection-product-grid');
//                 this.productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);

//                 const nextPage = doc.querySelector('.load-more-button');
//                 if (!nextPage) {
//                     this.loadMoreButton.style.display = 'none';
//                 }

//                 window.history.pushState({ pageNum: this.pageNum }, '', `?page=${this.pageNum}`);

//                 this.updateLoadedProductsCount();
//                 this.updateProgressBar();

//                 this.spinner.classList.add('hidden'); // hide spinner
//                 this.loadMoreButtonText.textContent = 'Load more products'; // revert button text
//             });
//     }

//     updateLoadedProductsCount() {
//         const loadedProducts = this.productGrid.querySelectorAll('.product');
//         this.loadedProductsCount.innerText = loadedProducts.length;
//     }

//     updateProgressBar() {
//         const loadedProducts = this.productGrid.querySelectorAll('.product').length;
//         const totalProducts = parseInt(this.totalProductsCount.textContent);
//         const progressPercentage = (loadedProducts / totalProducts) * 100;

//         this.progressBar.style.width = `${progressPercentage}%`;
//         this.progressBar.setAttribute('aria-valuenow', progressPercentage);
//     }
// }

// new LoadMoreProducts();
/******/ })()
;
